module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_8004.a1d40f32.png";